var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"add-button w-100 text-align-center my-4 py-2"},_vm.$listeners),[_c('a-icon',{attrs:{"type":"plus"}}),_vm._v("  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }